<template>
  <div class="data-panel">
    <h3 class="data-title">Projetos</h3>
    <div v-if="!detail" style="color:#9ca3af;font-size:14px;">Carregando...</div>
    <table v-else class="admin-table">
      <thead>
        <tr>
          <th>Nome do projeto</th>
          <th>Responsáveis</th>
          <th>Criado em</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="p in detail.projects" :key="p.id">
          <td>{{ p.name }}</td>
          <td>{{ (p.responsibleUsernames || []).join(', ') || p.ownerUsername }}</td>
          <td>{{ formatDate(p.createdAt) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { inject } from 'vue'

export default {
  name: 'AdminSysProjectsTab',
  setup() {
    const detail = inject<any>('adminDetail')

    const formatDate = (d: string) => {
      if (!d) return ''
      try { return new Date(d).toLocaleDateString('pt-BR') } catch { return d }
    }

    return { detail, formatDate }
  }
}
</script>

<style lang="scss">
.data-panel { padding: 28px; }
.data-title { font-size: 16px; font-weight: 600; color: #111827; margin: 0 0 14px; }

.admin-table {
  width: 100%;
  border-collapse: collapse;

  th {
    background: #f9fafb;
    padding: 10px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid #e5e7eb;
  }

  td {
    padding: 12px 16px;
    font-size: 14px;
    color: #374151;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
  }

  tr:last-child td { border-bottom: none; }
  tr:hover td { background: #f9fafb; }

  code { font-size: 13px; background: #f3f4f6; padding: 2px 6px; border-radius: 4px; }
}
</style>
